import { SubFlowIcon } from "@signet/ui";
import { defineWebModule } from "@signet/web-kit";
import { EnterPage } from "./enter.tsx";
import { MonthsPage } from "./months.tsx";
import { SubsNowPanel } from "./now-panel.tsx";
import { SubsNowStat } from "./now-stat.tsx";
import { FlowPage } from "./page.tsx";
import "./subs.css";

/* The web half of Sub Flow: the sub flow, the months, the entry page, and a panel on Now. */

const str = (value: unknown) => (typeof value === "string" && /^\d{4}-\d{2}(-\d{2})?$/.test(value) ? value : undefined);

export default defineWebModule({
  id: "subs",
  // The people who type the subs in may hold only entry, so either opens Sub Flow; /subs sends them on to Enter subs.
  nav: { label: "Sub Flow", icon: SubFlowIcon, to: "/subs", needs: ["subs.flow:view", "subs.entry:view"] },
  routes: [
    { path: "/subs", component: FlowPage, needs: ["subs.flow:view", "subs.entry:view"], validateSearch: (raw) => ({ day: str(raw.day), from: str(raw.from), to: str(raw.to) }) },
    { path: "/subs/months", component: MonthsPage, needs: "subs.flow:view", validateSearch: (raw) => ({ month: str(raw.month) }) },
    { path: "/subs/enter", component: EnterPage, needs: "subs.entry:view", validateSearch: (raw) => ({ day: str(raw.day) }) },
  ],
  // Beside Visitors, Clicks and Revenue, after them (Jay, 2026-10-13).
  nowStats: [{ id: "subs.today", needs: "subs.flow:view", order: 40, component: SubsNowStat }],
  // A whole row, under Top links and above To-do.
  nowPanels: [{ id: "subs.now", needs: "subs.flow:view", order: 45, wide: true, component: SubsNowPanel }],
  commands: [
    { id: "subs.flow", label: "Sub Flow", to: "/subs", needs: "subs.flow:view", hint: "Today's subs by band", keywords: "subs subscribers flow poor average strong popping" },
    { id: "subs.enter", label: "Enter subs", to: "/subs/enter", needs: "subs.entry:view", hint: "Sub Flow", keywords: "subs subscribers input type report daily" },
    { id: "subs.months", label: "Subs by month", to: "/subs/months", needs: "subs.flow:view", hint: "Sub Flow", keywords: "subs subscribers monthly month on month" },
  ],
});
